import styled from 'styled-components';
import { storeCommonStyles } from './commonStyles';

export const BukkuStoreStyled = styled.div`   
  ${storeCommonStyles}
  height: 100%;

  .ant-layout.main-layout {
    height: 100%;
    overflow: hidden;

    .inner-layout {
      .sider-mask {
        @media (width <= 991px) { /* Floating sidebar */
          position: absolute;
          z-index: 98;
          width: 100vw;
          height: calc(100% - 64px);
          background: rgba(0, 0, 0, 15%);
        }
      }

      .powered {
        padding: 28px 8px;
        text-align: center;

        img {
          height: 24px;
          vertical-align: baseline;
        }

        h3 {
          font-size: 15px;
          color: #595959;
        }

        h4 {
          font-size: 12px;
          font-weight: normal;
          color: #8c8c8c;

          a {
              color: #8c8c8c;
          }
        }
      }

    }

    .sider {
      z-index: 99;
      padding: 1rem 0;
      overflow-x: auto;
      background: #fff;
      border-right: 1px solid #d9d9d9;

      @media (width <= 991px) { /* Floating sidebar */
        position: absolute;
        height: calc(100% - 64px);
        border-right: 0;
        box-shadow: 2px 0 8px #8c8c8c;
      }
    }
  }

  .ant-layout-header {
    z-index: 100;
    padding: 1rem;
    background: #fff;
    box-shadow: 0 2px 8px #bfbfbf;

    &.header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .toggle-col {
      padding-right: 1rem;

      @media (width >= 992px) {
        display: none;
      }
    }

    .logo-col {
      /* stylelint-disable-next-line no-descending-specificity */
      img {
        max-height: 38px;
      }

      h1 {
        font-size: 18px;
      }
    }

    .icon__store-info {
        color: var(--neutralDark);
    }

    .anticon {
      font-size: 18px;
      vertical-align: middle;
    }

    .header-search {
      &.expanded {
        .anticon {
          padding-left: 8px;
        }
      }

      input {
        border-bottom: 1px solid #8c8c8c;

        @media (width <= 575px) {
          width: calc(100vw - 92px);
        }
      }
    }
  }

  .ant-layout-content {
    padding: 12px;
    overflow-x: auto;
  }

  .ant-layout-footer.footer__checkout {
    z-index: 30;
    padding: 0.6rem 1rem;
    color: white;
    background: #1FB6C6;

    .ant-badge-count {
        box-shadow: none;
        opacity: 0.9;
    }

    .ant-badge-multiple-words {
        padding: 0 5px;
    }
  }
`;
